<template functional>
  <div class="letter triaxle" v-if="props.item.triaxle" />
</template>

<script>
export default {
  name: "drayage-triaxle",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
